import React from "react";
import "./About.css";
import { Type } from "./Type";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import DescriptionIcon from "@material-ui/icons/Description";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import PublicIcon from "@material-ui/icons/Public";
import { Introduction } from "./Introduction";
import { Timeline } from "./Timeline";
import { Techstacks } from "./Techstacks";
// import resume from "../resume/Vivek_Gupta_Resume.pdf (6).pdf";

export const About = () => {
  return (
    <>
    <div id="home" className="aboutFix">
      <div className="about center">
        <h1 data-aos="fade-right">
          Hi, I am <span id="user-detail-name">Vivek Gupta</span>
        </h1>
        <Type />
        {/* <p className="about__desc" data-aos="fade-right">
          Aspiring MERN Developer who loves solving problems and building projects. I am equipped with a variety of technologies and tools to help me build the best possible product.
        </p> */}
        <div className="about__contact center">
          <a
            href="https://github.com/vivekbtu"
            aria-label="github"
            target="_blank"
            rel="noreferrer"
            className="link link--icon"
          >
            <GitHubIcon />
          </a>
          <a
            id="contact-email"
            href="mailto:bittubieber19@gmail.com"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <EmailIcon id="contact-email" />
          </a>
          <a
            id="contact-phone"
            href="tel:+917903461080"
            target="_blank"
            rel="noreferrer"
            aria-label="github"
            className="link link--icon"
          >
            <PhoneIcon id="contact-phone" />
          </a>
          <a
            href="https://www.linkedin.com/in/vivek-gupta-a89361233"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon />
          </a>
          <a
            id="resume-button-2"
            download
            href="https://github.com/vivekbtu/RESUME/files/14855865/Vivek_Gupta_Resume.pdf"
            // "https://github.com/vivekbtu/RESUME/files/11951159/Vivek_Gupta_Resume.pdf.pdf" 
            // href={"Vivek_Gupta_Resume.pdf"}
            // https://github.com/vivekbtu/RESUME/raw/main/Vivek_Gupta_Resume.pdf
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <DescriptionIcon id="resume-link-2" />
          </a>
          {/* <a
            href="https://www.facebook.com/aarush.gpa"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <FacebookIcon />
          </a> */}
          <a
            href="https://www.google.co.in/maps/place/Jainagar,+Bihar/@26.5876995,86.1169604,14z/data=!4m5!3m4!1s0x39ec25a0f275da8f:0x38215d9cc747d889!8m2!3d26.588412!4d86.1370182"
            aria-label="github"
            className="link link--icon"
            target="_blank"
            rel="noreferrer"
          >
            <PublicIcon />
          </a>
        </div>
      </div>
      <Introduction />
      <Timeline />
      <section id="#skills">
        <Techstacks />
      </section>
      </div>
    </>
  );
};
